.button {
  display: inline-flex;
  align-items: center;
  gap: 1rem;
  width: fit-content;
  padding: 0.5rem 0.5rem 0.5rem 1rem;
  border: 2px solid var(--color-muted);
  border-color: var(--color-muted);
  border-radius: 8px;
  background: transparent;
  color: var(--color-text);
  text-decoration: underline;
  cursor: pointer;
  font: inherit;
  transition: border-color 0.2s ease;
  &:hover:not(:disabled) {
    border-color: var(--color-primary);
  }
}

.button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.portraits {
  display: inline-flex;
  flex-shrink: 0;
}

.image {
  width: 3.125rem;
  height: 3.125rem;
  flex-shrink: 0;
  border: 2px solid var(--color-background);
  border-radius: 50%;
  object-fit: cover;
}

.image + .image {
  margin-left: -0.75rem;
}

.onDark {
  background: var(--color-cta);
  border-color: var(--color-cta);
  border-radius: 999px;
  color: var(--color-primary-deep);
  font-weight: 400;
  text-decoration: none;
  &:hover:not(:disabled) {
    border-color: var(--color-text-on-primary);
  }
}

.onDark .image {
  height: 2rem;
  width: 2rem;
}

.button:focus-visible {
  outline: 3px solid var(--color-accent);
  outline-offset: 2px;
}
